import { render, staticRenderFns } from "./ycyx.vue?vue&type=template&id=46ebae15&scoped=true&"
import script from "./ycyx.vue?vue&type=script&lang=js&"
export * from "./ycyx.vue?vue&type=script&lang=js&"
import style0 from "./ycyx.vue?vue&type=style&index=0&id=46ebae15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ebae15",
  null
  
)

export default component.exports